import coreApiClient from "@/providers/core-api/CoreApi"

export default {
  getWorkshopServices(workspaceId, payload){
    return coreApiClient.sendRequest("get", `/v1/workspaces/${workspaceId}/workshop-services`, payload)
  }
}
